export class MockReferenceService {
  getReferencesByName = jasmine.createSpy('getReferencesByName');
  getReferencesByConcessionSlug = jasmine.createSpy('getReferencesByConcessionSlug');
}
